<template>
  <div class="about">
    <h1>An app to improve efficiency</h1>
  </div>
</template>
